import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

const FloatingWhatsApp = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 5000);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    const handleClick = () => {
        window.open('https://wa.me/message/PORUCT4Z63S6E1', '_blank');
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0, opacity: 0 }}
                    className="fixed bottom-20 sm:bottom-24 right-4 sm:right-6 z-30"
                >
                    <AnimatePresence>
                        {showTooltip && (
                            <motion.div
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 20 }}
                                className="absolute bottom-full right-0 mb-2 bg-white shadow-lg rounded-lg p-3 w-48 sm:w-64"
                            >
                                <button
                                    onClick={() => setShowTooltip(false)}
                                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                                >
                                    <X size={14} />
                                </button>
                                <p className="text-sm text-secondary font-medium mb-1">¿Necesitas ayuda?</p>
                                <p className="text-xs text-gray-600">Chatea con un agente en WhatsApp</p>
                            </motion.div>
                        )}
                    </AnimatePresence>

                    <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={handleClick}
                        className="w-12 h-12 sm:w-16 sm:h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-lg flex items-center justify-center text-white transition-colors"
                        aria-label="Contactar por WhatsApp"
                    >
                        <MessageCircle size={22} className="sm:w-7 sm:h-7" />
                    </motion.button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default FloatingWhatsApp;
